module.exports = __webpack_public_path__ + "static/media/Top_GPX_new_trimmed.bd20e044.png";